import { render, staticRenderFns } from "./LeadBoard.vue?vue&type=template&id=984d6f1a&"
import script from "./LeadBoard.vue?vue&type=script&lang=js&"
export * from "./LeadBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports